import { styled } from '@mui/material/styles';

export const StyledFilter = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;

  .filter-container {
    display: flex;
    align-items: flex-end;
    gap: 8px;
  }

  @media only screen and (max-width: 900px) {
    .last-updated {
      margin: 8px 0;
    }
  }
  @media only screen and (max-width: 1280px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    .filter-container {
      width: 100%;
    }
  }
`;
